import { Buffer } from "buffer";
import { ethers } from "ethers";
import type { BaseDerivationTypedData } from "./baseDerivation";

/** Local device-vault unlock only. Intentionally stable across EVM networks;
 * network spending keys are derived independently from the random master root. */
export function buildMasterVaultTypedData(
  wallet: string,
): BaseDerivationTypedData {
  return {
    version: "stealthos-master-vault-v1",
    domain: { name: "StealthOS Master Wallet", version: "1" },
    types: {
      UnlockStealthOSWallet: [
        { name: "wallet", type: "address" },
        { name: "origin", type: "string" },
        { name: "purpose", type: "string" },
      ],
    },
    message: {
      wallet: ethers.getAddress(wallet).toLowerCase(),
      origin: window.location.origin,
      purpose:
        "Unlock my encrypted StealthOS wallet on this device across supported networks. This is not a transaction.",
    },
  };
}

export async function signMasterVault(
  signer: ethers.Signer,
  wallet: string,
  isCurrent: () => boolean,
) {
  const typedData = buildMasterVaultTypedData(wallet);
  if (!isCurrent()) throw new Error("Wallet connection changed during setup.");
  const signatureHex = await signer.signTypedData(
    typedData.domain,
    typedData.types,
    typedData.message,
  );
  if (!isCurrent()) throw new Error("Wallet connection changed during setup.");
  if (
    ethers
      .verifyTypedData(
        typedData.domain,
        typedData.types,
        typedData.message,
        signatureHex,
      )
      .toLowerCase() !== wallet.toLowerCase()
  )
    throw new Error(
      "The wallet did not sign the requested setup message with the connected account.",
    );
  return {
    signatureHex,
    newSignatureHex: signatureHex,
    signatureB64: Buffer.from(ethers.getBytes(signatureHex)).toString("base64"),
    typedData,
    commit: async () => {},
  };
}
